import {isLessonAudioPath} from './sourceAudioPath';

export type ReferenceType='letter'|'syllable'|'word';
export interface Reference {type:ReferenceType;text:string;audio_url:string;}
export interface ReferenceSource {source:string;license:string;items:Reference[];}

// This validates the transport contract; source quality and rights need separate review.
export function readPronunciationReferences(value:unknown):ReferenceSource|null {
 if(!value||typeof value!=='object'||Array.isArray(value))return null;
 const data=value as Record<string,unknown>;
 if(data.verification!=='source_record'||typeof data.source!=='string'||!data.source.trim()||
    typeof data.license!=='string'||!data.license.trim()||!Array.isArray(data.items)||data.items.length<1||data.items.length>3)return null;
 const items:Reference[]=[];const types=new Set<string>();
 for(const item of data.items as unknown[]){
  if(!item||typeof item!=='object'||Array.isArray(item))return null;
  const row=item as Record<string,unknown>;
  if((row.type!=='letter'&&row.type!=='syllable'&&row.type!=='word')||types.has(row.type)||
     typeof row.text!=='string'||!row.text.trim()||Array.from(row.text).length>100||!isLessonAudioPath(row.audio_url))return null;
  types.add(row.type);items.push({type:row.type,text:row.text,audio_url:row.audio_url});
 }
 return {source:data.source,license:data.license,items};
}
